import React from "react";
import TargetTypeNameField from "../TargetTypeNameField";

function ComplianceNameField({ compliance, setCompliance }) {
    const onChange = (value) => setCompliance({ ...compliance, name: value, base: false });

    return (
        <TargetTypeNameField
            value={compliance.name}
            onValueChange={onChange}
            label="Name"
        />
    );
}

export default ComplianceNameField;
